<div [formGroup]="form">
  <nb-card class="manual-invoice">
    <nb-card-header>
      <h4>{{ "dialogs.manualInvoice.title" | translate }}</h4>
    </nb-card-header>
    <nb-card-body>
      <p class="hint">{{ "dialogs.manualInvoice.hint" | translate }}</p>

      <div class="lines" formArrayName="lines">
        <span class="label">{{ "dialogs.manualInvoice.fields.description" | translate }}</span>
        <span class="label">{{ "dialogs.manualInvoice.fields.quantity" | translate }}</span>
        <span class="label">{{ "dialogs.manualInvoice.fields.unit" | translate }}</span>
        <span class="label">{{ "dialogs.manualInvoice.fields.unitPrice" | translate }}</span>
        <span></span>
        @for (line of lines.controls; track line; let i = $index) {
          <ng-container [formGroupName]="i">
            <input
              nbInput
              fullWidth
              formControlName="description"
              [attr.aria-label]="'dialogs.manualInvoice.fields.description' | translate"
              [status]="showInputError(line.get('description')) ? 'danger' : 'basic'"
            />
            <input
              nbInput
              fullWidth
              type="number"
              min="1"
              formControlName="quantity"
              [attr.aria-label]="'dialogs.manualInvoice.fields.quantity' | translate"
              [status]="showInputError(line.get('quantity')) ? 'danger' : 'basic'"
            />
            <input
              nbInput
              fullWidth
              formControlName="unit"
              [placeholder]="'dialogs.manualInvoice.unitPlaceholder' | translate"
              [attr.aria-label]="'dialogs.manualInvoice.fields.unit' | translate"
            />
            <input
              nbInput
              fullWidth
              type="number"
              min="0"
              step="0.01"
              formControlName="unit_price_eur"
              [attr.aria-label]="'dialogs.manualInvoice.fields.unitPrice' | translate"
              [status]="showInputError(line.get('unit_price_eur')) ? 'danger' : 'basic'"
            />
            <button
              nbButton
              ghost
              size="small"
              type="button"
              [disabled]="lines.length === 1"
              [attr.aria-label]="'dialogs.manualInvoice.removeLine' | translate"
              (click)="removeLine(i)"
            >
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </ng-container>
        }
      </div>
      <div class="row-between">
        <button nbButton size="small" status="basic" type="button" (click)="addLine()">
          <nb-icon icon="plus-outline"></nb-icon>
          <span>{{ "dialogs.manualInvoice.addLine" | translate }}</span>
        </button>
        <strong>{{ "dialogs.manualInvoice.total" | translate }}: {{ totalCents / 100 | currency: "EUR" }}</strong>
      </div>

      <div class="grid">
        <label class="label" for="mi-start">{{ "dialogs.manualInvoice.fields.serviceStart" | translate }}</label>
        <input id="mi-start" nbInput fullWidth type="date" formControlName="service_start" />
        <label class="label" for="mi-end">{{ "dialogs.manualInvoice.fields.serviceEnd" | translate }}</label>
        <input id="mi-end" nbInput fullWidth type="date" formControlName="service_end" />
        <label class="label" for="mi-terms">{{ "dialogs.manualInvoice.fields.paymentTerms" | translate }}</label>
        <input
          id="mi-terms"
          nbInput
          fullWidth
          type="number"
          min="0"
          max="180"
          formControlName="payment_terms_days"
          [placeholder]="'dialogs.manualInvoice.paymentTermsPlaceholder' | translate: { days: paymentTermsDays }"
          [status]="showInputError(form.get('payment_terms_days')) ? 'danger' : 'basic'"
        />
        <label class="label" for="mi-note">{{ "dialogs.manualInvoice.fields.note" | translate }}</label>
        <textarea id="mi-note" nbInput fullWidth rows="2" formControlName="note"></textarea>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="danger" outline type="button" (click)="close()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button nbButton status="primary" type="button" [disabled]="saving" [nbSpinner]="saving" (click)="submit()">
        {{ "dialogs.manualInvoice.submit" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</div>
